/**
 * @generated SignedSource<<0319c3a34a5f844677b6422baa3d027e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HomeHeaderViewQuery$variables = {
  goalUpdatesCreatedAfter?: string | null;
  goalUpdatesCreatedBefore?: string | null;
  includeReadingModeGoalUpdates: boolean;
  includeReadingModeProjectUpdates: boolean;
  loadWritingModeGoalsQuery: boolean;
  loadWritingModeProjectsQuery: boolean;
  pendingUpdateGoalsTqlQuery: string;
  pendingUpdateProjectsTqlQuery: string;
  projectUpdatesCreatedAfter?: string | null;
  projectUpdatesCreatedBefore?: string | null;
  workspaceUUID?: string | null;
};
export type HomeHeaderViewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HeaderUpdateButtons">;
};
export type HomeHeaderViewQuery = {
  response: HomeHeaderViewQuery$data;
  variables: HomeHeaderViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "goalUpdatesCreatedAfter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "goalUpdatesCreatedBefore"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeReadingModeGoalUpdates"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeReadingModeProjectUpdates"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loadWritingModeGoalsQuery"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loadWritingModeProjectsQuery"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pendingUpdateGoalsTqlQuery"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pendingUpdateProjectsTqlQuery"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectUpdatesCreatedAfter"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectUpdatesCreatedBefore"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUUID"
},
v11 = {
  "kind": "Variable",
  "name": "workspaceUUID",
  "variableName": "workspaceUUID"
},
v12 = {
  "kind": "Literal",
  "name": "first",
  "value": 50
},
v13 = [
  "LATEST_UPDATE_DATE_ASC",
  "NAME_ASC"
],
v14 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUUID"
},
v15 = {
  "kind": "ScalarField",
  "name": "id"
},
v16 = [
  {
    "kind": "ScalarField",
    "name": "creationDate"
  },
  (v15/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "name": "HomeHeaderViewQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "goalUpdatesCreatedAfter",
            "variableName": "goalUpdatesCreatedAfter"
          },
          {
            "kind": "Variable",
            "name": "goalUpdatesCreatedBefore",
            "variableName": "goalUpdatesCreatedBefore"
          },
          {
            "kind": "Variable",
            "name": "includeReadingModeGoalUpdates",
            "variableName": "includeReadingModeGoalUpdates"
          },
          {
            "kind": "Variable",
            "name": "includeReadingModeProjectUpdates",
            "variableName": "includeReadingModeProjectUpdates"
          },
          {
            "kind": "Variable",
            "name": "loadWritingModeGoalsQuery",
            "variableName": "loadWritingModeGoalsQuery"
          },
          {
            "kind": "Variable",
            "name": "loadWritingModeProjectsQuery",
            "variableName": "loadWritingModeProjectsQuery"
          },
          {
            "kind": "Variable",
            "name": "pendingUpdateGoalsTqlQuery",
            "variableName": "pendingUpdateGoalsTqlQuery"
          },
          {
            "kind": "Variable",
            "name": "pendingUpdateProjectsTqlQuery",
            "variableName": "pendingUpdateProjectsTqlQuery"
          },
          {
            "kind": "Variable",
            "name": "projectUpdatesCreatedAfter",
            "variableName": "projectUpdatesCreatedAfter"
          },
          {
            "kind": "Variable",
            "name": "projectUpdatesCreatedBefore",
            "variableName": "projectUpdatesCreatedBefore"
          },
          (v11/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "HeaderUpdateButtons"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v10/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v9/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "HomeHeaderViewQuery",
    "selections": [
      {
        "condition": "loadWritingModeProjectsQuery",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "pendingProjectUpdates",
            "args": [
              (v12/*: any*/),
              {
                "kind": "Variable",
                "name": "q",
                "variableName": "pendingUpdateProjectsTqlQuery"
              },
              {
                "kind": "Literal",
                "name": "sort",
                "value": (v13/*: any*/)
              },
              (v14/*: any*/)
            ],
            "concreteType": "ProjectConnection",
            "kind": "LinkedField",
            "name": "projectTql",
            "plural": false,
            "selections": [
              {
                "concreteType": "ProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Project",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ProjectUpdate",
                        "kind": "LinkedField",
                        "name": "latestUserUpdate",
                        "plural": false,
                        "selections": (v16/*: any*/)
                      },
                      (v15/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "loadWritingModeGoalsQuery",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "pendingGoalUpdates",
            "args": [
              (v12/*: any*/),
              {
                "kind": "Variable",
                "name": "q",
                "variableName": "pendingUpdateGoalsTqlQuery"
              },
              {
                "kind": "Literal",
                "name": "sorts",
                "value": (v13/*: any*/)
              },
              (v14/*: any*/)
            ],
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "goalTql",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "GoalUpdate",
                        "kind": "LinkedField",
                        "name": "latestUserUpdate",
                        "plural": false,
                        "selections": (v16/*: any*/)
                      },
                      (v15/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "includeReadingModeProjectUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "projectCount",
            "args": [
              {
                "kind": "Variable",
                "name": "createdAfter",
                "variableName": "projectUpdatesCreatedAfter"
              },
              {
                "kind": "Variable",
                "name": "createdBefore",
                "variableName": "projectUpdatesCreatedBefore"
              },
              (v11/*: any*/)
            ],
            "kind": "ScalarField",
            "name": "allWatchedProjectUpdatesCount"
          }
        ]
      },
      {
        "condition": "includeReadingModeGoalUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "goalCount",
            "args": [
              {
                "kind": "Variable",
                "name": "createdAfter",
                "variableName": "goalUpdatesCreatedAfter"
              },
              {
                "kind": "Variable",
                "name": "createdBefore",
                "variableName": "goalUpdatesCreatedBefore"
              },
              (v11/*: any*/)
            ],
            "kind": "ScalarField",
            "name": "allWatchedGoalUpdatesCount"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "90c0a60b2819f040cfc60fa727c876aa",
    "id": null,
    "metadata": {},
    "name": "HomeHeaderViewQuery",
    "operationKind": "query",
    "text": "query HomeHeaderViewQuery(\n  $workspaceUUID: UUID\n  $goalUpdatesCreatedAfter: DateTime\n  $goalUpdatesCreatedBefore: DateTime\n  $includeReadingModeGoalUpdates: Boolean!\n  $includeReadingModeProjectUpdates: Boolean!\n  $projectUpdatesCreatedBefore: DateTime\n  $projectUpdatesCreatedAfter: DateTime\n  $pendingUpdateProjectsTqlQuery: String!\n  $pendingUpdateGoalsTqlQuery: String!\n  $loadWritingModeProjectsQuery: Boolean!\n  $loadWritingModeGoalsQuery: Boolean!\n) {\n  ...HeaderUpdateButtons_2r8fyP\n}\n\nfragment HeaderUpdateButtons_2r8fyP on Query {\n  ...WritingModeButton_data_48lAvG\n  ...ReadingModeButton_data_3Cmsau\n}\n\nfragment ReadingModeButton_data_3Cmsau on Query {\n  projectCount: allWatchedProjectUpdatesCount(createdBefore: $projectUpdatesCreatedBefore, createdAfter: $projectUpdatesCreatedAfter, workspaceUUID: $workspaceUUID) @include(if: $includeReadingModeProjectUpdates)\n  goalCount: allWatchedGoalUpdatesCount(workspaceUUID: $workspaceUUID, createdBefore: $goalUpdatesCreatedBefore, createdAfter: $goalUpdatesCreatedAfter) @include(if: $includeReadingModeGoalUpdates)\n}\n\nfragment WritingModeButton_data_48lAvG on Query {\n  pendingProjectUpdates: projectTql(first: 50, workspaceUuid: $workspaceUUID, q: $pendingUpdateProjectsTqlQuery, sort: [LATEST_UPDATE_DATE_ASC, NAME_ASC]) @include(if: $loadWritingModeProjectsQuery) {\n    edges {\n      node {\n        latestUserUpdate {\n          creationDate\n          id\n        }\n        id\n      }\n    }\n  }\n  pendingGoalUpdates: goalTql(first: 50, workspaceUuid: $workspaceUUID, q: $pendingUpdateGoalsTqlQuery, sorts: [LATEST_UPDATE_DATE_ASC, NAME_ASC]) @include(if: $loadWritingModeGoalsQuery) {\n    edges {\n      node {\n        latestUserUpdate {\n          creationDate\n          id\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b5d3878db314740494486e08f47dd824";

export default node;
